module.exports = __webpack_public_path__ + "img/41f5d53f5e9c32b4.599d9ce2.jpg";